import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-landing-container',
  templateUrl: './landing-container.component.html',
  styleUrls: ['./landing-container.component.scss']
})
export class LandingContainer implements OnInit {

  constructor(private titleService: Title) { }

  ngOnInit(): void {
      this.titleService.setTitle("VPI Triangle");
  }
}
